import { lazy } from "react";

// use lazy for better code splitting, a.k.a. load faster
const Document = lazy(() => import("../pages/Document"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Facility = lazy(() => import("../pages/Facility"));
const Employee = lazy(() => import("../pages/Employee"));
const Users = lazy(() => import("../pages/Users"));
const UserLoginHistory = lazy(() => import("../pages/UserLoginHistory"));
const AddFacility = lazy(() => import("../pages/Add/AddFacility"));
const Moderators = lazy(() => import("../pages/Moderators"));
const AddModerator = lazy(() => import("../pages/Add/AddModerator"));
const AddUser = lazy(() => import("../pages/Add/AddUsers"));
const AddEmployee = lazy(() => import("../pages/Add/AddEmployee"));
const EmployeeProfile = lazy(() => import("../pages/Profiles/EmployeeProfile"));
const UserProfile = lazy(() => import("../pages/Profiles/UserProfile"));
const EmployeeAttendance = lazy(() => import("../pages/EmployeeAttendance"));
const Complaint = lazy(() => import("../pages/Complaints"));
const QrCodeGenerator = lazy(() => import("../pages/Generateqr"));
const CertificateGenerator = lazy(() => import("../pages/GenerateCertificate"));
const Form = lazy(() => import("../components/Form/Forms"));
const Report = lazy(() => import("../components/Report/Report"));
const InvoiceGeneration = lazy(() => import("../pages/InvoiceGeneration"));
const SheetChanges = lazy(() => import("../pages/SheetChanges"));
const FieldAgents = lazy(() => import("../pages/FieldAgents"));
const PaymentVerification = lazy(() => import("../pages/PaymentVerification"));
const OldBillsGenerator = lazy(() => import("../pages/OldBillsGenerator"));
const AddFieldAgent = lazy(() => import("../pages/Add/AddFieldAgent"));
const PendingAmountLogs = lazy(() => import("../pages/PendingAmountLogs"));
const routes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/addfieldagent",
    component: AddFieldAgent,
  },
  {
    path: "/addfacility",
    component: AddFacility,
  },
  {
    path: "/invoice",
    component: InvoiceGeneration,
  },
  {
    path: "/adduser",
    component: AddUser,
  },
  {
    path: "/addemployee",
    component: AddEmployee,
  },
  {
    path: "/facilities",
    component: Facility,
  },
  {
    path: "/pending-amount-logs",
    component: PendingAmountLogs,
  },
  { path: "/old-bills", 
    component: OldBillsGenerator },
  {
    path: "/sheet-changes",
    component: SheetChanges,
  },
  {
    path: "/payment-verification",
    component: PaymentVerification,
  },
  {
    path: "/users",
    component: Users,
  },
  {
    path: "/login-history",
    component: UserLoginHistory,
  },
  {
    path: "/moderators",
    component: Moderators,
  },
  {
    path: "/addmoderator",
    component: AddModerator,
  },
  {
    path: "/employees",
    component: Employee,
  },
  {
    path: "/complaints",
    component: Complaint,
  },
  {
    path: "/document",
    component: Document,
  },
  {
    path: "/generateqr",
    component: QrCodeGenerator,
  },
  {
    path: "/generatecertificate",
    component: CertificateGenerator,
  },
  {
    path: "/pdf",
    component: Form,
  },
  {
    path: "/reports",
    component: Report,
  },
  {
    path: "/employee/:id",
    component: EmployeeProfile,
  },
  {
    path: "/user/:id",
    component: UserProfile,
  },
  {
    path: "/attendance/:id",
    component: EmployeeAttendance,
  },
  {
    path: "/field-agents",
    component: FieldAgents,
  },
];

export default routes;